import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'

export const useAverageMarketRateMessageStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: brandColors.green0,
    padding: theme.spacing(1.5),
    margin: `${theme.spacing(1.5)} 0 ${theme.spacing(1)}`,

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  text: {
    color: brandColors.green3,
  },
  marketRateContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  rateWrapper: {
    margin: `0 0 0 ${theme.spacing(0.5)}`,
  },
  skeletonWrapper: {
    margin: `${theme.spacing(1.5)} 0 ${theme.spacing(1)}`,
  },
}))
